import { ALERT_BANNER_CODE } from "../Enums/alertCode";

export const AlertBannerCodeMap: Record<ALERT_BANNER_CODE, string> = {
  [ALERT_BANNER_CODE.INTERNAL_SERVER_ERROR]:
    "Something went wrong, please try again.",
  [ALERT_BANNER_CODE.FAIL_TO_SEND_EMAIL]:
    "We are unable to send OTP code. Please verify your email and try again or refresh the browser.",
  [ALERT_BANNER_CODE.ACCESS_DENIED]:
    "Access denied. Please log in and try again, or verify that you have the necessary permissions to access this resource.",
  [ALERT_BANNER_CODE.FAILED_TO_UPLOAD_FILE_TO_S3]:
    "Something went wrong while uploading your file, please refresh the browser and try again.",
  [ALERT_BANNER_CODE.INVALID_OR_UNPOSTED_JOB]:
    "This job does not exist or it's unposted. Please try a different job.",
  [ALERT_BANNER_CODE.INVALID_OTP]:
    "OTP provided is invalid. Please check your email or resend OTP again.",
  [ALERT_BANNER_CODE.MEMBER_NOT_FOUND]:
    "Email doesn't exist, please register or sign in with a different email.",
  [ALERT_BANNER_CODE.NOT_FOUND]:
    "The requested resource was not found or the input is invalid. Please refresh your browser and try again.",
  [ALERT_BANNER_CODE.INTERNAL_ERROR]: "Something went wrong, please try again.",
  [ALERT_BANNER_CODE.INVALID_CREDENTIALS]:
    "Invalid email or password. Please check your credentials and try again.",
  [ALERT_BANNER_CODE.DUPLICATE_KEYS]:
    "One or more fields are already existing. Please verify and try again.",
  [ALERT_BANNER_CODE.DUPLICATE_PASSWORD]:
    "Please use a new password. Old and new password are similar.",
  [ALERT_BANNER_CODE.EMPLOYEE_NOT_ALLOWED]:
    "Access denied. This account is not allowed to access this portal. Please reach out to your admin",
  [ALERT_BANNER_CODE.EMPLOYEE_NOT_ACTIVE]:
    "Access denied. This account is not activated. Please reach out to your admin for activation"
};
